webpackJsonp([213720915766396],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(87);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__(19);
	
	var _grayPercentage = __webpack_require__(26);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var github = function github(name) {
	  return 'https://github.com/soska/' + name;
	};
	
	var Project = function Project(_ref) {
	  var name = _ref.name,
	      link = _ref.link,
	      children = _ref.children;
	
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        marginTop: (0, _typography.rhythm)(1),
	        marginBottom: (0, _typography.rhythm)(1),
	        padding: (0, _typography.rhythm)(1),
	        background: 'white',
	        borderRadius: (0, _typography.rhythm)(0.15),
	        boxShadow: 'rgba(0,0,0,.05) 6px 6px 0'
	      }
	    },
	    Glamor.createElement(
	      'a',
	      {
	        href: link,
	        css: {
	          display: 'block',
	          paddingBottom: (0, _typography.rhythm)(0.5),
	          marginBottom: (0, _typography.rhythm)(0.5),
	          borderBottom: '1px solid ' + (0, _grayPercentage2.default)(90)
	        }
	      },
	      name
	    ),
	    Glamor.createElement(
	      'div',
	      null,
	      children
	    )
	  );
	};
	
	var Projects = function Projects() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'Projects | Armando Sosa' }),
	    Glamor.createElement(
	      'h2',
	      null,
	      'Open Source'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'Keyboardist', link: github('keyboardist.js') },
	      'Easy way to add key shortcuts to your Javascript application.'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'React Keyboardist', link: github('react-keyboardist') },
	      'React wrapper for Keyboardist'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'Unavatar', link: github('unavatar') },
	      'React component to add alphanumeric avatars to users.'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'Adaptables', link: github('adaptables') },
	      'React component to create responsive tables.'
	    )
	  );
	};
	exports.default = Projects;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-67177017293e84e54b6d.js